import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "vi",
  "use": "vi-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"vi\">\n<rect width=\"40\" height=\"40\" fill=\"#1D1D1B\" />\n<path d=\"M19.7422 16.0114L16.5088 24.8475L13.3804 16.0114H10L14.7451 29H18.1255L22.8916 16.0114H19.7422Z\" fill=\"white\" />\n<path d=\"M25.9634 14.2008C27.1811 14.2008 28 13.2834 28 12.028C28 10.8691 27.1811 10 25.9634 10C24.7456 10 23.9267 10.9174 23.9267 12.1004C23.9267 13.2834 24.7456 14.2008 25.9634 14.2008ZM24.3257 29H27.6011V16.0114H24.3257V29Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol